export default __webpack_public_path__ + "static/media/yantramanav.bold.cbb6cfe3.ttf";